import { useLogError } from '@/src/common/hooks/useLogError'
import { graphql } from '@api/mesa'
import { useMutation } from '@apollo/client'
import { useEffect } from 'react'

export function useClientToken() {
  const logError = useLogError()

  const [generateClientToken, { data }] = useMutation(
    graphql(`
      mutation GenerateClientToken {
        generateClientToken {
          clientToken
        }
      }
    `),
  )

  useEffect(() => {
    generateClientToken()
      .then(
        (response) =>
          response.errors &&
          logError(new Error('Generate client token failed', { cause: response })),
      )
      .catch(logError)
  }, [generateClientToken, logError])

  return data?.generateClientToken.clientToken
}
